import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { Alert, Button, Field, Input, Logo } from '@pnl/ui';
import { api } from '../lib/api';

export function ForgotPasswordPage() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  async function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.requestPasswordReset({ email });
    } catch {
      // 204 anti-enumeration
    } finally {
      setSubmitting(false);
      setDone(true);
    }
  }

  return (
    <div className="animate-fade-in space-y-8">
      <div className="lg:hidden">
        <Logo />
      </div>
      <div>
        <p className="text-2xs text-brand-500 font-semibold uppercase tracking-widest">
          Recuperação de senha
        </p>
        <h2 className="font-display text-ink-900 mt-2 text-3xl font-semibold tracking-tight">
          Esqueci minha senha
        </h2>
        <p className="text-ink-500 mt-1 text-sm">
          Informe seu email e enviaremos um link para redefinir a senha.
        </p>
      </div>

      {done ? (
        <div className="space-y-4">
          <Alert tone="success">
            Se houver uma conta com esse email, enviamos um link de redefinição. Verifique a caixa
            de entrada e o spam.
          </Alert>
          <Link to="/login" className="text-brand-600 hover:text-brand-700 text-sm font-medium">
            ← Voltar para o login
          </Link>
        </div>
      ) : (
        <form className="space-y-4" onSubmit={handleSubmit}>
          <Field label="Email" htmlFor="email" required>
            <Input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              leadingIcon={<Mail size={14} />}
              placeholder="seu@email.com"
              disabled={submitting}
            />
          </Field>
          <Button type="submit" block size="lg" loading={submitting}>
            {submitting ? 'Enviando…' : 'Enviar link de redefinição'}
          </Button>
          <Link
            to="/login"
            className="text-brand-600 hover:text-brand-700 block text-xs font-medium"
          >
            ← Voltar para o login
          </Link>
        </form>
      )}
    </div>
  );
}
